import {Component} from 'react'
import Helmet from 'react-helmet'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import Footer from '../Footer/Footer.jsx'
import Navbar from '../Navbar/Navbar.jsx'
import ConnectedMenu, {FOR_DESKTOP, FOR_MOBILE} from "../ConnectedMenu/ConnectedMenu.jsx"

import sharedConf from '../../../shared/conf.js'

import './DashboardLayout.scss'

class DashboardLayout extends Component {
  static propTypes = {
    className: PropTypes.string,
    helmet: PropTypes.object,
    id: PropTypes.string,
    navbar: PropTypes.element,
    navbarContained: PropTypes.bool,
    navbarSearch: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    helmet: {title: '', description: ''},
    id: null,
    navbar: null,
    navbarContained: true,
    navbarFixed: true,
    navbarForceAccountType: sharedConf.accountTypes.freelance,
    navbarLocked: true,
    navbarSearch: true,
  }

  constructor(props) {
    super(props)
    this.state = {
      isCompany: false,
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevProps.user && this.props.user && prevProps.user.id !== this.props.user.id) {
      this.setState({
        isCompany: !(this.props.user && this.props.user.account_type === sharedConf.accountTypes.freelance)
      })
    }
  }

  render() {
    const {helmet} = this.props

    const title = "Twineeds | Consultants Ingénierie, Achats, Supply, Finance"
    const description = "Twineeds connecte entreprises et consultants indépendants en ingénierie, achats, supply, finance ou RH, avec un haut niveau d’expertise pour chaque mission."

    return (
      <div id={this.props.id} className={`dashboard-layout ${this.props.className}`}>
        <Helmet>
          <title>{helmet.title || title}</title>
          <meta name="description" content={helmet.description || description}/>
          <meta property="og:title" content={helmet.title || title}/>
          <meta property="og:description" content={helmet.description || description}/>
          <meta property="twitter:title" content={helmet.title || title}/>
          <meta property="twitter:description" content={helmet.description || description}/>
        </Helmet>

        {this.props.navbar ?
          this.props.navbar :
          <Navbar
            contained={this.props.navbarContained}
            fixed={!!this.props.user}
            forceAccountType={this.state.isCompany ? sharedConf.accountTypes.do : sharedConf.accountTypes.freelance}
            locked={!this.props.user}
            search={this.props.navbarSearch}
          />
        }

        {this.props.user && (<ConnectedMenu user={this.props.user} isFor={FOR_MOBILE}/>)}
        <div id="layout-content-wrapper" style={{display: "flex"}}>
          {this.props.user && (<ConnectedMenu user={this.props.user}  isFor={FOR_DESKTOP}/>)}

          <div className="layout-content" style={{flex: "auto"}}>
            {this.props.children}
          </div>
        </div>
        <Footer/>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.currentUser.user,
  })
)(DashboardLayout)
